import React from 'react';
import {Container, Row, Col, Table, Pagination} from 'react-bootstrap';
import btc from './home_assets/home_btc.svg';
import vector from './home_assets/home_vector.svg';
import eth from './home_assets/home_eth.svg';

import './home_styles/homepagetable.css';
import Chartt from '../graph/chartt';

import "./home_styles/homepagetable.css";
// import Graph from '../graph/graph';

export default function HomepageTable() {
  let active = 1;
  let items: any = [];
  for (let number = 1; number <= 5; number++) {
    items.push(
      <Pagination.Item key={number} active={number === active}>
        {number}
      </Pagination.Item>
    );
  }

  return (
    <>
      <Container>
        <Row>
          <Col>
            <div className="home_table mt-5">
              <Table responsive borderless className="">
                <thead className="home_table_th">
                  <tr>
                    <th>Currency</th>
                    <th>Market Price</th>
                    <th>24h Change</th>
                    <th>6h Market</th>
                  </tr>
                </thead>
                <tbody className='home_table_tb'>
                    <tr className='home_dark_row'>
                        <td><img src={btc} alt="Bitcoin" /> Bitcoin</td>
                        <td>$ 0.084</td>
                        <td>14.80%</td>
                        <td className='hometable_chart'>
                          <Chartt />
                        </td>
                    </tr>
                    <tr>
                        <td><img src={eth} alt="Ethereum" /> LilBulls</td>
                        <td>$ 0.084</td>
                        <td>14.80%</td>
                        <td className='hometable_chart'>
                          <Chartt />
                        </td>
                    </tr>
                    <tr className='home_dark_row'>
                        <td><img src={btc} alt="Bitcoin" /> Bitcoin</td>
                        <td>$ 0.084</td>
                        <td>14.80%</td>
                        <td className='hometable_chart'>
                          <Chartt />
                        </td>
                    </tr>
                    <tr>
                        <td><img src={eth} alt="Ethereum" /> LilBulls</td>
                        <td>$ 0.084</td>
                        <td>14.80%</td>
                        <td className='hometable_chart'>
                          <Chartt />
                        </td>
                    </tr>
                    <tr className='home_dark_row'>
                        <td><img src={btc} alt="Bitcoin" /> Bitcoin</td>
                        <td>$ 0.084</td>
                        <td>14.80%</td>
                        <td className='hometable_chart'>
                          <Chartt />
                        </td>
                    </tr>
                    <tr>
                        <td><img src={eth} alt="Ethereum" /> LilBulls</td>
                        <td>$ 0.084</td>
                        <td>14.80%</td>
                        <td className='hometable_chart'>
                          <Chartt />
                        </td>
                    </tr>
                </tbody>
              </Table>
            </div>
            <div className="home_below_table d-flex justify-content-between mt-4">
              <div className="home_below_link">
                <a href="">View All</a>
              </div>
              <div className="">
                <Pagination size="sm">
                  {items}
                  <Pagination.Ellipsis />
                  <Pagination.Item>{20}</Pagination.Item>
                </Pagination>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
